import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wms-dialog-footer',
  standalone: true,
  templateUrl: './wms-dialog-footer.component.html',
  styleUrls: ['./wms-dialog-footer.component.less']
})
export class WmsDialogFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
